import React from "react";
import { Link } from "react-router-dom";

export default function HubButton({
  to,
  whatsappLink,
  title,
  subtitle,
  image,
}) {
  // Estrutura interna com suas classes originais
  const buttonContent = (
    <>
      <div className="hub-avatar">
        <img src={image} alt={title} />
        <span className="hub-avatar-glow" />
      </div>

      <div className="hub-button-content">
        <div className="hub-button-title">{title}</div>
        <div className="hub-button-subtitle">{subtitle}</div>
      </div>
    </>
  );

  // Se passou whatsappLink, mantemos a tag Link para herdar o CSS, mas controlamos o clique para ir pro Whats
  if (whatsappLink) {
    return (
      <Link 
        to="#" 
        className="hub-button"
        onClick={(e) => {
          e.preventDefault(); // Impede a página de recarregar ou rolar para o topo
          window.open(whatsappLink, "_blank", "noopener,noreferrer");
        }}
      >
        {buttonContent}
      </Link>
    );
  }

  // Fallback seguro caso algum outro lugar do site ainda use rota normal
  return (
    <Link to={to} className="hub-button">
      {buttonContent}
    </Link>
  );
}